import React from 'react';
import PropTypes from 'prop-types';

import classNames from '../../utils/classNames';

import styles from './form-item.scss';

export default function FormItem(props) {
    const containerStyles = classNames(styles.container, {
        [styles.error]: props.error instanceof Error,
    });

    const labelStyles = classNames(styles.label, {
        [styles.required]: props.required,
    });

    const captionStyles = classNames(styles.caption, {
        [styles.caption_error]: props.error instanceof Error,
    });
    const caption = props.error instanceof Error ? props.error.message : props.caption;

    return <div className={containerStyles} style={props.style}>
        {typeof props.label === 'string' &&
            <div className={styles.top}>
                <h4 className={labelStyles}>{props.label}</h4>
            </div>
        }
        {props.children}
        {(typeof caption === 'string') &&
            <div className={styles.bottom}>
                <span className={captionStyles}>{caption}</span>
            </div>
        }
    </div>;
};

FormItem.propTypes = {
    /**
     * Hint under the text field.
     */
    caption: PropTypes.string,
    /**
     * Label above the text field.
     */
    label: PropTypes.string,
    /**
     * Error object to display field validation.
     */
    error: PropTypes.instanceOf(Error),
    required: PropTypes.bool,
    children: PropTypes.element,
    style: PropTypes.object,
};
